import { useContext, useState } from "react";
import { Button, Loading, PanelMenu, PanelMenuItem, PhytoViewType, useTitle } from "modules/common";
import { useGetPhytoViewEntries } from "modules/phytoview/hooks/phytoViewHook";
import PhytoViewSelectModal from "modules/phytoview/components/PhytoViewSelectModal";
import { GetPhytoViewEntriesRequest } from "services/phytoview/request";
import { PhytoViewTable } from "modules/phytoview/components/PhytoViewTable";
import { PredmetOpazanjaType } from "modules/phytoview/constants/PredmetOpazanjaType";
import { AccessibilityContext } from "./AccessibilityContext";
export interface IPhytoViewModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    isPost: boolean;
    editItemId: number | null;
}

const initialRequest: GetPhytoViewEntriesRequest = {
    page: 1,
    pageSize: 10,
    isActive: true,
    phytoViewType: PhytoViewType.EconomicUnits,
};

const phytoview: PanelMenuItem[] = [
    {
        label: "Županije",
        link: "Zupanije",
        type: PhytoViewType.County,
    },
    {
        label: "JLS",
        link: "Jls",
        type: PhytoViewType.JLS,
    },
    {
        label: "Gospodarske jedinice",
        link: "GospodarskeJedinice",
        type: PhytoViewType.EconomicUnits,
    },
    {
        label: "Štetni organizmi - podkategorije",
        link: "PredmetOpazanja",
        type: PhytoViewType.HarmfulOrganismsSubCategories,
    },
    {
        label: "Štetni organizmi - kulture",
        link: "PredmetOpazanjaVrste",
        type: PhytoViewType.HarmfulOrganismsCultures,
    },
    {
        label: "Faze rasta i razvoja biljaka - podkategorije",
        link: "PredmetOpazanjaFenofaze",
        type: PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubCategories,
    },
    {
        label: "Faze rasta i razvoja biljaka - kulture",
        link: "PredmetOpazanjaFenofazeVrste",
        type: PhytoViewType.PhasesOfPlantGrowthAndDevelopmentCultures,
    },
    {
        label: "Faze rasta i razvoja biljaka - sorte",
        link: "PredmetOpazanjaFenofazeSorte",
        type: PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSorts,
    },
    {
        label: "Štetni organizmi - vrsta",
        link: "StetniOrganizamVrste",
        type: PhytoViewType.HarmfulOrganismsSpecies,
    },
    {
        label: "Štetni organizmi - tip",
        link: "StetniOrganizamVrsteModels",
        type: PhytoViewType.HarmfulOrganismsType,
    },
    {
        label: "Prostor uzgoja",
        link: "ProstorUzgoja",
        type: PhytoViewType.CultivationArea,
    },
    {
        label: "Štetni organizmi - atributi vrste štetnog organizma",
        link: "StetniOrganizamAtributVrste",
        type: PhytoViewType.HarmfulOrganismsAttributesOfTheTypepOfHarmfulOrganism,
    },
    {
        label: "Štetni organizmi - atributi podskupa vrste štetnog organizma",
        link: "StetniOrganizamAtributVrsteModels",
        type: PhytoViewType.HarmfulOrganismsAttributesOfASubsetOfTheTypeOfHarmfulOrganism,
    },
    {
        label: "Faze rasta i razvoja biljaka - glavne faze",
        link: "Fenofaze",
        type: PhytoViewType.PhasesOfPlantGrowthAndDevelopmentTheMainPhases,
    },
    {
        label: "Faze rasta i razvoja biljaka - podfaze",
        link: "FenofazePodfaze",
        type: PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubphases,
    },
];

const getPhytoViewtype = (label: string) => {
    switch (label) {
        case "Županije":
            return PhytoViewType.County;
        case "JLS":
            return PhytoViewType.JLS;
        case "Gospodarske jedinice":
            return PhytoViewType.EconomicUnits;
        case "Štetni organizmi - podkategorije":
            return PhytoViewType.HarmfulOrganismsSubCategories;
        case "Štetni organizmi - kulture":
            return PhytoViewType.HarmfulOrganismsCultures;
        case "Faze rasta i razvoja biljaka - podkategorije":
            return PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubCategories;
        case "Faze rasta i razvoja biljaka - kulture":
            return PhytoViewType.PhasesOfPlantGrowthAndDevelopmentCultures;
        case "Faze rasta i razvoja biljaka - sorte":
            return PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSorts;
        case "Štetni organizmi - vrsta":
            return PhytoViewType.HarmfulOrganismsSpecies;
        case "Štetni organizmi - tip":
            return PhytoViewType.HarmfulOrganismsType;
        case "Prostor uzgoja":
            return PhytoViewType.CultivationArea;
        case "Štetni organizmi - atributi vrste štetnog organizma":
            return PhytoViewType.HarmfulOrganismsAttributesOfTheTypepOfHarmfulOrganism;
        case "Štetni organizmi - atributi podskupa vrste štetnog organizma":
            return PhytoViewType.HarmfulOrganismsAttributesOfASubsetOfTheTypeOfHarmfulOrganism;
        case "Faze rasta i razvoja biljaka - glavne faze":
            return PhytoViewType.PhasesOfPlantGrowthAndDevelopmentTheMainPhases;
        case "Faze rasta i razvoja biljaka - podfaze":
            return PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubphases;
        default:
            return PhytoViewType.Unknown;
    }
};

const menuItems: PanelMenuItem[] =
    phytoview.map(item => ({
        label: item.label,
        link: item.link,
        type: item.type,
    })) ?? [];

export const PhytoViewAdministration = () => {
    useTitle("Phytoview šifrarnici - eSavjetnik");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPost, setIsPost] = useState(false);
    const [editItemId, setEditItemId] = useState<number | null>(null);
    const [menuItem, setMenuItem] = useState<PanelMenuItem>(menuItems[0]);
    const handlePostMethod = () => {
        setIsPost(true);
        setIsModalOpen(true);
    };

    const [request, setRequest] = useState<GetPhytoViewEntriesRequest>(initialRequest);
    const { data: dataAll, isFetching } = useGetPhytoViewEntries(request, menuItem.link);
    const handleItemClick = (item: PanelMenuItem) => {
        setMenuItem(item);
        const isHarmfulOrganism =
            item.type === PhytoViewType.HarmfulOrganismsSubCategories ||
            item.type === PhytoViewType.HarmfulOrganismsCultures;

        const isFenofaze =
            item.type === PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubCategories ||
            item.type === PhytoViewType.PhasesOfPlantGrowthAndDevelopmentCultures;

        const { type, ...restRequest } = request;
        setRequest({
            ...restRequest,
            phytoViewType: getPhytoViewtype(item.label),
            page: 1,
            ...(isHarmfulOrganism && { type: PredmetOpazanjaType.Stetnici }),
            ...(isFenofaze && { type: PredmetOpazanjaType.Fenofaze }),
        });
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setEditItemId(null);
    };
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <div className="phytoview-container">
            <div className="phytoview-heading">
                <div className="phytoview-filters">
                    <span>PHYTOVIEW ŠIFRARNICI</span>
                </div>
                {menuItem.type !== PhytoViewType.HarmfulOrganismsSubCategories &&
                    menuItem.type !==
                        PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubCategories &&
                    menuItem.type !== PhytoViewType.HarmfulOrganismsSpecies &&
                    menuItem.type !==
                        PhytoViewType.HarmfulOrganismsAttributesOfTheTypepOfHarmfulOrganism && (
                        <Button
                            size="small"
                            className="phytoview-button"
                            variant="primary"
                            lowVision={lowVision}
                            disabled={!menuItem || isFetching}
                            onClick={handlePostMethod}
                        >
                            KREIRAJ NOVI UNOS
                        </Button>
                    )}
            </div>
            <div className="phytoview-content">
                <PanelMenu
                    items={menuItems}
                    selectedItem={menuItem}
                    onItemClicked={handleItemClick}
                />
                <div className="phytoview-content-btn">
                    <Button
                        size="small"
                        className="phytoview-button"
                        variant="primary"
                        lowVision={lowVision}
                        disabled={!menuItem || isFetching}
                        onClick={handlePostMethod}
                    >
                        KREIRAJ NOVI UNOS
                    </Button>
                </div>
                {isFetching ? (
                    <Loading />
                ) : (
                    <PhytoViewTable
                        phytoviews={dataAll}
                        isLoading={isFetching}
                        phytoviewType={getPhytoViewtype(menuItem?.label ?? "")}
                        onPageChange={page => setRequest({ ...request, page })}
                        onPageSizeChange={pageSize => setRequest({ ...request, pageSize, page: 1 })}
                        page={request.page}
                        pageSize={request.pageSize}
                        selectedOption={menuItem.type!}
                    />
                )}
            </div>
            {isModalOpen && (
                <PhytoViewSelectModal
                    selectedOption={menuItem.type!}
                    isPost={isPost}
                    isModalOpen={isModalOpen}
                    editItemId={editItemId}
                    onClose={handleClose}
                />
            )}
        </div>
    );
};
